"use client"
import {Accordion, AccordionItem} from "@heroui/accordion";
import {Heading2, Italic} from "@/components/NotionPrimitives";
import {useMonitoring} from "@/components/monitoring";

export default function Accordian(props) {
    const { onClickTrack } = useMonitoring()


    return (<>
            <div className={"text-center mt-8"}>
                <Heading2>
                    {props.Title}
                </Heading2>
            </div>
            <div className="flex justify-center">
                <Accordion className="mx-2 w-full sm:mx-0 md:w-7/12" variant="light">
                    {
                        props.sections.map(({title, content}, key) => (
                            <AccordionItem onClick={onClickTrack("FaQ Item", { question: title})} key={key} aria-label={`Answer to "${title}" question`}
                                           title={<Italic>{key + 1}. {title}</Italic>}>
                                {content}
                            </AccordionItem>
                        ))
                    }
                </Accordion>
            </div>
        </>
    )
}